module.exports = __webpack_public_path__ + "static/img/icon_facebook.54af0f8c.png";